export var setInput = function (input) { return ({
    type: "SET_INPUT",
    input: input
}); };
